import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

// export const apiURL = 'http://127.0.0.1:8001/api/v1'
export const apiURL = 'https://api.savoycontrole.com.br/api/v1'
export const cepURL = 'https://viacep.com.br/ws'



// WEBPACK FOOTER //
// ./src/config.js